<script lang="ts">
    import { _ } from "svelte-i18n"

    export let position: OperationPosition
</script>

<div class="table lighttable">
    <div class="tablerow thead">
        <div class="col mw-60 w-60">
            <div class="cell_inner">{$_("positions.sequenceNumber")}</div>
        </div>
        <div class="col mw-60">
            <div class="cell_inner">{$_("positions.quantity")}</div>
        </div>
        <div class="col mw-60">
            <div class="cell_inner">{$_("positions.unit")}</div>
        </div>
        <div class="col mw-60">
            <div class="cell_inner">{$_("positions.articleNumber")}</div>
        </div>
        <div class="col mw-250 dominantxl">
            <div class="cell_inner">{$_("positions.description")}</div>
        </div>
    </div>

    {#each position?.items || [] as item}
        <div class="tablerow trow">
            <div class="col mw-60 w-60">
                {item.sequenceNumber || ""}
            </div>
            <div class="col mw-60">
                {item.amount || ""}
            </div>
            <div class="col mw-60">
                {item.measureUnit || ""}
            </div>
            <div class="col mw-60">
                {item.number || ""}
            </div>
            <div class="col mw-250 dominantxl">
                {item.description || ""}
            </div>
        </div>
    {/each}
</div>
